module.exports = __webpack_public_path__ + "static/media/country_co.6b773e39.webp";